module.exports = __webpack_public_path__ + "img/neibuqunliao.a6a7a720.svg";